"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networks = void 0;
const metadata_1 = require("../metadata");
exports.networks = {
    ethereum: {
        name: metadata_1.chains.ethereum.name,
        image: metadata_1.chains.ethereum.image,
        networkId: 11155111,
        publicRpcUrl: 'https://sepolia.infura.io/v3/84842078b09946638c03157f83405213',
        fallbackPublicRpcUrls: [],
        explorerUrls: ['https://sepolia.etherscan.io'],
        subgraphUrl: 'https://api.thegraph.com/subgraphs/name/hop-protocol/hop-sepolia',
        multicall: '0xcA11bde05977b3631167028862bE2a173976CA11',
        txOverrides: {
            minGasLimit: 1000000
        },
        averageBlockTimeSeconds: 12
    }
};
